export const onWindowFocus = async () => {
  if (document.hasFocus()) return;
  return new Promise<void>(resolve => {
    window.addEventListener('focus', () => {
      resolve();
    });
  });
};
